import { banner, InterNational, InterUNi, profile, yoga } from "../assets";
import { getOrganizationLogo } from "../assets/logos";
import HeroSection from "../components/HeroSection";

const CareerHighlightsPage = () => {
    // Achievement data with icons and categories
    const achievements = [
        {
            id: 1,
            category: "Leadership",
            title: "Vice Chancellor",
            subtitle: "Sampurnanand Sanskrit University",
            description: "Leading one of the world's largest Sanskrit universities with a 234+ year legacy, elevating it into an international bastion of learning.",
            organization: "Sampurnanand Sanskrit University",
            badge: "Current Position",
            stats: { years: "2023-Present" }
        },
        {
            id: 2,
            category: "Academic Leadership",
            title: "Member, Governing Council",
            subtitle: "Centre for Yogic Sciences (IUC-YS)",
            description: "Serving on the governing council of the Inter-University Centre for Yogic Sciences, contributing to policy formulation and academic excellence in yogic studies.",
            icon: <img src={yoga} alt="yoga" className="w-10 h-10 object-contain"/>,
            badge: "Current Position",
            stats: { scope: "National", impact: "Yogic Sciences" }
        },
          {
            id: 3,
            category: "Cultural Heritage",
            title: "Trustee - Shri Kashi Vishwanath Mandir",
            subtitle: "Varanasi",
            description: "Associated with the governance and advisory framework of one of India's most sacred and culturally significant temple trusts.",
            organization: "Shri Kashi Vishwanath Mandir",
            badge: "Current Position",
            stats: { significance: "National Heritage", location: "Varanasi" }
        },
       {
            id: 4,
            category: "Policy Leadership",
            title: "Member, Higher Education Council",
            subtitle: "Government of Madhya Pradesh",
            description: "Contributing to policy formulation and strategic planning for higher education development in Madhya Pradesh, providing expert guidance on academic excellence and institutional governance.",
            organization: "Government of Madhya Pradesh",
            badge: "Leadership Role",
            stats: { scope: "State Level", impact: "Higher Education Policy" }
        },
        {
            id: 5,
            category: "Academic Leadership",
            title: "Director, Internal Quality Assurance Cell (IQAC)",
            subtitle: "Shri Lal Bahadur Shastri National Sanskrit University",
            description: "Providing academic oversight, administrative leadership, and strategic guidance for institutional growth and quality enhancement.",
            organization: "Shri Lal Bahadur Shastri National Sanskrit University",
            badge: "Leadership Role",
            stats: { role: "Director IQAC", focus: "Quality Assurance" }
        },
        {
            id: 6,
            category: "Administrative Leadership",
            title: "Chairperson, Management Committee",
            subtitle: "Shri Bhagwan Das Adarsh Sanskrit Mahavidyalaya",
            description: "Leading the management committee responsible for strategic planning, policy implementation, and administrative oversight of university operations and development initiatives.",
            organization: "Shri Bhagwan Das Adarsh Sanskrit Mahavidyalaya",
            badge: "Leadership Role",
            stats: { role: "Chairperson", scope: "University Management" }
        },
        
        {
            id: 7,
            category: "Academic Leadership",
            title: "Chairperson, Management Committee",
            subtitle: "Rani Padmavati Tara Yog Tantra Adarsh Sanskrit Mahavidyalaya",
            description: "Providing academic oversight, administrative leadership, and strategic guidance for institutional growth and quality enhancement at Shivpur, Varanasi.",
            organization: "Rani Padmavati Tara Yog Tantra Adarsh Sanskrit Mahavidyalaya",
            badge: "Leadership Role",
            stats: { role: "Chairperson", location: "Shivpur, Varanasi" }
        },
        {
            id: 8,
            category: "Research Leadership",
            title: "Deputy Coordinator – UGC SAP DRS-I, DRS-II & DRS-III",
            subtitle: "Jyotish Department",
            description: "Led the coordination of UGC Special Assistance Programme (SAP) at three levels (DRS-I, DRS-II, DRS-III) for the Department of Jyotish, advancing research excellence and academic infrastructure.",
            organization: "University Grants Commission (UGC)",
            badge: "Research Leadership",
            stats: { program: "UGC SAP DRS", levels: "I, II & III" }
        },
         {
            id: 9,
            category: "Cultural Leadership",
            title: "Vice-President",
            subtitle: "Sanskrit Bharti, Delhi",
            description: "Providing leadership and strategic direction to a nationally reputed organization dedicated to the promotion, preservation, and propagation of Sanskrit language and culture.",
            organization: "Sanskrit Bharti, Delhi",
            badge: "Leadership Role",
            stats: { scope: "National", impact: "Sanskrit Promotion" }
        },
        
    ];

   

    return (
        <div className="min-h-screen bg-secondary-50">
            <HeroSection bgImage={banner} frontImage={profile}>
                <div className="text-left space-y-4 lg:space-y-6">
                    <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-heritage-ivory leading-tight">
                        Career Highlights
                    </h1>
                    
                    <h2 className="text-xl lg:text-2xl xl:text-3xl font-sans font-semibold text-heritage-gold">
                        Achievements, Contributions & Leadership
                    </h2>
                    
                    <p className="text-lg lg:text-xl text-heritage-ivory/95 font-serif leading-relaxed">
                        Comprehensive overview of major achievements, academic contributions, and leadership initiatives in Sanskrit education and cultural preservation.
                    </p>
                </div>
            </HeroSection>

            <div className="container mx-auto px-4 max-w-7xl py-16">
                

                {/* Major Achievements */}
                <section className="mb-16">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-12 text-center">
                        Major Achievements & Recognition
                    </h2>
                    <div className="flex ">
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl">
                            {achievements.map((achievement) => (
                                <div 
                                    key={achievement.id}
                                    className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 relative flex flex-col"
                                >
                                    {/* Badge */}
                                    <div className="absolute -top-4 -right-4 bg-primary-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-medium z-10">
                                        {achievement.badge}
                                    </div>
                                    
                                   
                                    
                                    {/* Icon */}
                                    <div className="text-5xl mb-4">
                                        {achievement.organization ? (() => {
                                            const logo = getOrganizationLogo(achievement.organization);
                                            if (typeof logo === 'object' && logo.type === 'image') {
                                                return <img src={logo.src} alt={logo.alt} className="w-12 h-12 object-contain"/>;
                                            }
                                        return logo;
                                    })() : achievement.icon}
                                </div>
                                
                                {/* Content */}
                                <h3 className="text-heading-md font-serif text-heritage-maroon mb-2">
                                    {achievement.title}
                                </h3>
                                <h4 className="text-primary-600 font-semibold mb-3 text-sm">
                                    {achievement.subtitle}
                                </h4>
                                <p className="text-secondary-600 leading-relaxed mb-4 text-sm">
                                    {achievement.description}
                                </p>
                                
                                {/* Stats */}
                                <div className="flex flex-wrap gap-2">
                                    {Object.entries(achievement.stats).map(([key, value]) => (
                                        <span 
                                            key={key}
                                            className="bg-secondary-100 text-secondary-700 px-3 py-1 rounded-full text-xs font-medium"
                                        >
                                            {value}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </section>

              

                {/* Leadership Initiatives & Impact */}
                <section className="mb-16">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-12 text-center">
                        Leadership Initiatives & Impact
                    </h2>
                    <div className="space-y-8">
                        <div className="bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex items-start flex-col lg:flex-row">
                            <div className="mr-6 flex-shrink-0 w-16 h-16 flex items-center justify-center">
                                <img 
                                    src={getOrganizationLogo("NAAC 'A' Grade Achievement (2024)").src} 
                                    alt="NAAC A Grade" 
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-heading-lg font-serif text-heritage-maroon mb-3">
                                    NAAC 'A' Grade Achievement (2024)
                                </h3>
                                <p className="text-secondary-600 leading-relaxed mb-4">
                                    Led Sampurnanand Sanskrit Vishwavidyalaya to achieve NAAC 'A' grade in third cycle evaluation, recognizing academic quality, research excellence, administrative transparency, and dedication to preserving Indian cultural values.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-semibold">
                                        Academic Excellence Recognition
                                    </div>
                                    <div className="bg-secondary-100 text-secondary-700 px-4 py-2 rounded-full text-sm">
                                        University Community & Sanskrit Education
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex items-start flex-col lg:flex-row">
                            <div className="mr-6 flex-shrink-0 w-16 h-16 flex items-center justify-center">
                                <img 
                                    src={getOrganizationLogo("Cultural Heritage Preservation").src} 
                                    alt="Cultural Heritage Preservation" 
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-heading-lg font-serif text-heritage-maroon mb-3">
                                    Cultural Heritage Preservation
                                </h3>
                                <p className="text-secondary-600 leading-relaxed mb-4">
                                    Leading multiple cultural organizations including Sanskrit Bharti as Vice-President and serving as Trustee of Shri Kashi Vishwanath Mandir, preserving India's spiritual and linguistic heritage.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-semibold">
                                        National Cultural Impact
                                    </div>
                                    <div className="bg-secondary-100 text-secondary-700 px-4 py-2 rounded-full text-sm">
                                        Sanskrit Community & Devotees
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex items-start flex-col lg:flex-row">
                            <div className="text-5xl mr-6 flex-shrink-0">🎓</div>
                            <div className="flex-1">
                                <h3 className="text-heading-lg font-serif text-heritage-maroon mb-3">
                                    Academic Governance Excellence
                                </h3>
                                <p className="text-secondary-600 leading-relaxed mb-4">
                                    Serving on governing councils of multiple universities including Jagadguru Rambhadracharya Divyang University and contributing to policy formulation in Madhya Pradesh Higher Education Council.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-semibold">
                                        Multi-University Governance
                                    </div>
                                    <div className="bg-secondary-100 text-secondary-700 px-4 py-2 rounded-full text-sm">
                                        Higher Education Sector
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex items-start flex-col lg:flex-row">
                            <div className="text-sm mr-6 flex-shrink-0"><img src={InterUNi} alt="Inter University" className="w-20 h-20"/></div>
                            <div className="flex-1">
                                <h3 className="text-heading-lg font-serif text-heritage-maroon mb-3">
                                    Inter-University Collaboration Network
                                </h3>
                                <p className="text-secondary-600 leading-relaxed mb-4">
                                    Established MOUs with leading institutions across India to strengthen Sanskrit and Vedic studies programs through various board memberships and collaborative initiatives.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-semibold">
                                        Multi-University Partnership
                                    </div>
                                    <div className="bg-secondary-100 text-secondary-700 px-4 py-2 rounded-full text-sm">
                                        25+ Universities
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex items-start flex-col lg:flex-row">
                            <div className="text-sm mr-6 flex-shrink-0"><img src={InterNational} alt="International" className="w-20 h-20"/></div>
                            <div className="flex-1">
                                <h3 className="text-heading-lg font-serif text-heritage-maroon mb-3">
                                    International Sanskrit Promotion
                                </h3>
                                <p className="text-secondary-600 leading-relaxed mb-4">
                                    Chief Organiser of World Sanskrit Sammelan 2019 and Academic Representative at Kumbh Conclave 2024-25, promoting Sanskrit studies globally.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-semibold">
                                        Global Sanskrit Movement
                                    </div>
                                    <div className="bg-secondary-100 text-secondary-700 px-4 py-2 rounded-full text-sm">
                                        International Sanskrit Community
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex items-start flex-col lg:flex-row">
                            <div className="text-5xl mr-6 flex-shrink-0">🏫</div>
                            <div className="flex-1">
                                <h3 className="text-heading-lg font-serif text-heritage-maroon mb-3">
                                    Smart Campus Development
                                </h3>
                                <p className="text-secondary-600 leading-relaxed mb-4">
                                    Modernized university infrastructure with state-of-the-art classrooms, e-library services, and digital learning platforms at Sampurnanand Sanskrit University.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <div className="bg-accent-100 text-accent-700 px-4 py-2 rounded-full text-sm font-semibold">
                                        Campus-wide Transformation
                                    </div>
                                    <div className="bg-secondary-100 text-secondary-700 px-4 py-2 rounded-full text-sm">
                                        15,000+ Students & Faculty
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default CareerHighlightsPage;